import { X } from 'lucide-react'

interface LinkBankModalProps {
  isOpen: boolean
  onClose: () => void
  onLinkBank: () => void
  onUseDocumentUploads: () => void
  onReturnToApplication: () => void
}

export function LinkBankModal({
  isOpen,
  onClose,
  onLinkBank,
  onUseDocumentUploads,
  onReturnToApplication,
}: LinkBankModalProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-[calc(100vw-24px)] sm:max-w-2xl w-full safe-area-bottom">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900">Please Link Your Bank Account</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-6">
          <p className="text-gray-700 mb-6 leading-relaxed">
            Linking your bank is the fastest and most accurate method for verifying your income
            sources. Verifying your income without linking your bank may delay your application.
            Please confirm your selection.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={onLinkBank}
              className="flex-1 px-4 py-2 bg-[#1597ff] text-white rounded-md hover:bg-[#0d7acc] transition-colors font-medium"
            >
              Link My Bank
            </button>
            <button
              onClick={onUseDocumentUploads}
              className="flex-1 px-4 py-2 border border-[#1597ff] text-[#1597ff] bg-white rounded-md hover:bg-blue-50 transition-colors font-medium"
            >
              Use Document Uploads for Income Verification
            </button>
            <button
              onClick={onReturnToApplication}
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 bg-white rounded-md hover:bg-gray-50 transition-colors font-medium"
            >
              Return to Application
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

